<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="8.33" stroke="currentColor" stroke-width="1.5" />
        <path
            d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
        />
    </svg>
</template>
